// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';

// styles
import './styles/graphic.scss';

/* develblock:start */
const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child();

window.onload = () => {
  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};
